export default "__VITE_ASSET__D29sHxD3__"